import CustomSlider from "./custom-slider";
import SidePopup, { popupElement } from "./side-popup";

class ReviewsSlider {
  private sliderTrack: HTMLElement | null = null;
  private customSlider: CustomSlider | null = null;

  private section: HTMLElement | null = null;
  private activeReviewObj: popupElement | null = null;
  private activeReviewIndex: number = 0;
  private popup: SidePopup | null = null;
  private items: HTMLElement[] = [];
  private reviewsCases: popupElement[] = [];

  constructor() {
    this.sliderTrack = document.querySelector(".reviews__slider-track-el");
    if (!this.sliderTrack) return;
    this.customSlider = new CustomSlider(this.sliderTrack, {
      endless: true,
    });

    this.section = document.querySelector('.reviews');
    this.activeReviewIndex = 0;

    document.addEventListener('reviewsCasesLoaded', (event: Event) => {
      if (!this.section) return;
      this.reviewsCases = (event as CustomEvent).detail.cases;
      this.activeReviewObj = this.reviewsCases[this.activeReviewIndex];
      this.popup = new SidePopup((event as CustomEvent).detail.controls);
      this.items = Array.from(this.section.querySelectorAll('.reviews__slider-item')) || [];
      const $this = this;
      this.popup.initCustomControls(()=>{this.showPrev($this)}, ()=>{this.showNext($this)});
      this.init();
    });

  }


  private showPrev($this: ReviewsSlider) {
    if (!$this.popup) return;
    let newIndex = $this.activeReviewIndex - 1;
    if (newIndex < 0) {
      newIndex = $this.reviewsCases.length - 1;
    }
    $this.activeReviewIndex = newIndex;
    $this.activeReviewObj = $this.reviewsCases[$this.activeReviewIndex];
    $this.popup.fillContent($this.activeReviewObj.content);
    $this.popup.showPopup();
  }

  private showNext($this: ReviewsSlider) {
    if (!$this.popup) return;
    let newIndex = $this.activeReviewIndex + 1;
    if (newIndex >= $this.reviewsCases.length) {
      newIndex = 0;
    }
    $this.activeReviewIndex = newIndex;
    $this.activeReviewObj = $this.reviewsCases[$this.activeReviewIndex];
    $this.popup.fillContent($this.activeReviewObj.content);
    $this.popup.showPopup();
  }

  private clickOpenPopUpButton(event: MouseEvent) {
    if (!this.popup) return;
    const target = event.target as HTMLElement;
    const popupId = target.dataset.popupId;
    if (!popupId) return;
    const reviewIndex = this.reviewsCases.findIndex((reviewObj: popupElement) => reviewObj.id === popupId);
    if (reviewIndex === -1) return;
    this.activeReviewIndex = reviewIndex;
    this.activeReviewObj = this.reviewsCases[this.activeReviewIndex];
    this.popup.fillContent(this.activeReviewObj.content);
    this.popup.showPopup();
  }

  private init() {
    if (!this.section) return;
    this.items.forEach((item: HTMLElement) => {
      const button = item.querySelector('.list__item-link') as HTMLButtonElement;
      if (!button) return;
      button.addEventListener('click', (event: Event) => {
        this.clickOpenPopUpButton(event as MouseEvent);
      });
    });

  }
}

export default function reviewsSlider() {
  return new ReviewsSlider();
}